import React, { useState } from 'react';

interface PlaceFormProps {
  addPlace: (value: string) => void;
}

function PlaceForm({ addPlace }: PlaceFormProps) {
  const [value, setValue] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement> | React.FocusEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!value) return;
    addPlace(value);
    setValue('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        className="input"
        width="80%"
        style={{ width: '80%' }}
        value={value}
        placeholder="entrez une adresse"
        onChange={(e) => setValue(e.target.value)}
        onBlur={handleSubmit as any}
      />
    </form>
  );
}

export default PlaceForm;
